import styled from "styled-components";

export const Container = styled.div`
    flex-grow: 1
`;

export const LinksWrapper = styled.div`
    margin-left: 50px
`;

export const AccountButtonContainer = styled.div`
    position: absolute;
    right: 25px;
`;